import { z } from 'zod';

import { zodCallOffResponseSchema } from '../validations';

// Request payload schema for cancelling a call-off
export const zodCancelCallOffPayloadSchema = z.object({
  notes: z.string().nullish(),
});

// Response schema (re-export from shared)
export { zodCallOffResponseSchema as zodCancelCallOffResponseSchema };
